import { type FC } from 'react';
import pointSuccess from '@assets/images/vault/point-success.svg';
import pointBoard from '@assets/images/vault/point-board.svg';
import copyIcon from '@assets/images/vault/copy-white.svg';
import styles from './index.module.scss';
import { useCode } from '@hooks/use-code';
import { useCopyToClipboard, useLocation } from 'react-use';
import { useNavigate } from 'react-router-dom';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { numericFormat } from '@utils/index';
import { notification } from 'antd';

interface OwnProps {
  point: OpenapiClientParrotVault.GetVaultInvitePointsResponse | undefined;
}

const PointLink: FC<OwnProps> = ({ point }) => {
  const [, copy] = useCopyToClipboard();
  const navigator = useNavigate();
  const location = useLocation();
  const { code } = useCode();

  return (
    <div className={styles.wrapper}>
      <div className={styles.img}>
        <img src={pointSuccess} />
      </div>
      <div className={styles.data}>
        <div>
          <div className={styles.data_title}>Your points</div>
          <div className={styles.data_value}>{numericFormat(point?.point || 0)}</div>
        </div>
        <div>
          <div className={styles.data_title}>Your rank</div>
          <div className={styles.data_value}>#{numericFormat(point?.ranking || 0)}</div>
        </div>
      </div>
      <div className={styles.div}>
        <div className={styles.board} onClick={() => navigator('/leaderboard')}>
          <img src={pointBoard} />
          <span>Points Leaderboard</span>
        </div>
      </div>
      <div className={styles.div}>
        <div
          className={styles.copy}
          onClick={() => {
            if (code?.code) {
              copy(location.origin + '/#/earn?code=' + code.code);
              notification.open({
                message: `Code is copied`,
              });
            }
          }}
        >
          <img src={copyIcon} />
          <span>Copy referral link</span>
        </div>
      </div>
      <div className={styles.text}>
        Invite friends to earn together while accumulating more points. Every point you earn is
        highly valuable,points are the sole credential for obtaining future rewards.
      </div>
    </div>
  );
};

export default PointLink;
